import { render, staticRenderFns } from "./onboardingModal.vue?vue&type=template&id=128035bb"
import script from "./onboardingModal.vue?vue&type=script&lang=js"
export * from "./onboardingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports